import { render, staticRenderFns } from "./EditBookingServiceDescription.vue?vue&type=template&id=72925dfa&"
import script from "./EditBookingServiceDescription.vue?vue&type=script&lang=js&"
export * from "./EditBookingServiceDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports